const ORIGIN_REGEX: RegExp = /^(https?:\/\/?[^/]*)\//;

export function getOrigin(url: string): string {
	const matches = url.match(ORIGIN_REGEX);

	return matches ?
		matches[1] :
		null;
}

export function getQueryParams(url: string): Record<string, string> {
	const [, queryParms] = url.split('?');

	if (!queryParms) {
		return {};
	}

	return queryParms
		.split('&')
		.map(param => param.split('=').map(decodeURIComponent))
		.reduce((output, current) => {
			const [key, value] = current;
			output[key] = value;

			return output;
		}, {});
}

export function stripQueryParams(url: string): string {
	return url.split('?')[0];
}

export function toRelativePath(url: string): string {
	if (!url.includes('://')) {
		return url;
	}

	// discard protocol and host
	return url
		.split('/')
		.slice(3) // discards [protocol, '', host]
		.join('/');
}

export function updateQueryParam(src: string, queryParam: string, value: string): string {
	const regEx = new RegExp('([?&])' + queryParam + '=.*?(&|$)', 'i'); // elint-disable-line
	const separator = src.indexOf('?') !== -1 ? '&' : '?';

	if (src.match(regEx)) {
		return src.replace(regEx, '$1' + queryParam + '=' + value + '$2');
	}

	return `${src}${separator}${queryParam}=${value}`;
}

export function updateQueryParams(src: string, queryParams:Record<string, string>): string {
	for (const [key, value] of Object.entries(queryParams)) {
		src = updateQueryParam(src, key, value);
	}
	return src;
}

export function retainQueryStr(src: string, retainQueryParams: string[]): string {
	const queryParams = getQueryParams(src);
	const srcWithoutQueryParams = stripQueryParams(src);
	const retainedQueryParams = Object.keys(queryParams).filter(q => retainQueryParams.includes(q));
	let newQueryParams = retainedQueryParams.map(q => `${q}=${queryParams[q]}`).join('&');

	if (newQueryParams) {
		newQueryParams = `?${newQueryParams}`;
	}

	return `${srcWithoutQueryParams}${newQueryParams}`;
}
